import PropTypes from 'prop-types';
import {Component} from 'react';
import overlay from '../../../../v2/components/ui/overlay.jsx';
import Language from '../../../../v2/lang/language';

class CopyToClipboard extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    props.overlay.setHeading(Language.getText('referralsSocialSharing.getLink'));
  }

  handleClick() {
    this.textarea.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Unable to copy selected text');
    }
  }

  render() {
    return (
      <div className="copyToClipboard">
        <h3 className="copyToClipboard_heading">{Language.getText('referralsSocialSharing.yourUniqueReferralLink')}</h3>
        <p className="copyToClipboard_explanation">{Language.getText('referralsSocialSharing.simplyCopyAndShare')}</p>
        <textarea
          ref={(el) => {
            this.textarea = el;
          }}
          className="copyToClipboard_textarea"
          value={this.props.value}
          readOnly="readonly"
        />
        <button
          type="button"
          onClick={this.handleClick}
          className="copyToClipboard_button"
        >
          {Language.getText('referralsSocialSharing.copy')}
        </button>
      </div>
    );
  }
}

CopyToClipboard.propTypes = {
  value: PropTypes.string.isRequired,
};

export default overlay({
  closeOnClickOutside: true,
  className: 'copyToClipboard',
})(CopyToClipboard);
